import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const publicApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const publicReportApi = {
  get: (token) => publicApi.get(`/reports/public/${token}`),
  submit: (token, data) => publicApi.put(`/reports/public/${token}`, data),
};
